module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"imported":"Imported","invited":"Invited","interviewed":"Passed the interview","inoffice_interview":"Invited for an in-office interview","job_offer":"Job offer","hired":"Hired","declined":"Declined"}}')
  delete Component.options._Ctor
}
